interface TrustSectionProps {
  answers: {
    annualFee?: string;
    priority?: string;
    occupation?: string;
  };
}

export default function TrustSection({ answers }: TrustSectionProps) {
  const getReasonText = () => {
    if (answers.annualFee === 'free' && answers.priority === 'cashback') {
      return '年会費無料で高還元率のカードを選ぶことで、日常の支払いでも効率的にポイントを貯めることができます。特に大手ECモール系カードはECモールでの利用で還元率が大幅にアップするため、ECモールやその他の関連サービスを利用する方には最適です。リクルートカードは基本還元率1.2%と業界最高水準で、どこで使っても高還元を実現できます。両カードとも年会費永年無料なので、維持コストを気にせず長く使い続けられるのが大きなメリットです。';
    } else if (answers.annualFee === 'free' && answers.occupation === 'student') {
      return '学生の方には審査基準が比較的緩やかで、年会費無料のカードがおすすめです。大手ECモール系カードやdカードは学生でも申込可能で、アルバイト収入があれば審査に通る可能性が高いです。初めてのクレジットカードとして、使いすぎを防ぐために利用限度額も低めに設定されるため安心です。また、ポイント還元率も高く、日常の買い物や教科書の購入などでお得にポイントを貯められます。卒業後も継続して使えるため、長期的に見てもメリットが大きいカードです。';
    } else if (answers.priority === 'benefits') {
      return '旅行保険や空港ラウンジなどの特典を重視する方には、ゴールドカード以上のステータスカードがおすすめです。三井住友カード ゴールド(NL)は年間100万円利用で翌年以降年会費永年無料になるため、実質無料でゴールドカードの特典を享受できます。海外旅行傷害保険は最高2,000万円まで補償され、空港ラウンジも無料で利用可能です。JALカードは飛行機に乗るたびにマイルが貯まり、旅行好きには欠かせない1枚です。特典を活用することで、年会費以上の価値を得られるのが大きな魅力です。';
    }
    return 'クレジットカードを選ぶ際は、年会費、還元率、特典、審査基準など、自分のライフスタイルに合った条件を重視することが重要です。年会費無料のカードは維持コストがかからず、初めてのカードとしても最適です。還元率が高いカードは日常の支払いでお得にポイントを貯められます。また、旅行保険や空港ラウンジなどの特典が充実したカードは、旅行好きの方に特におすすめです。自分の利用シーンに合ったカードを選ぶことで、最大限のメリットを享受できます。';
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
          なぜこのカードがおすすめなのか
        </h2>

        <div className="bg-red-50 rounded-2xl p-6 md:p-8 mb-12">
          <p className="text-sm md:text-base text-gray-700 leading-relaxed">
            {getReasonText()}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white border border-gray-200 rounded-2xl p-6">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-lightbulb-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">
              カード選びの注意点
            </h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-red-600 mt-0.5"></i>
                <span>年会費の条件を確認する</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-red-600 mt-0.5"></i>
                <span>ポイント還元率だけでなく使い道も確認</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-red-600 mt-0.5"></i>
                <span>自分の利用シーンに合った特典があるか</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-red-600 mt-0.5"></i>
                <span>複数枚持つ場合は管理しやすい枚数に</span>
              </li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-2xl p-6">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">
              審査に通るコツ
            </h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-red-600 mt-0.5"></i>
                <span>申込情報は正確に記入する</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-red-600 mt-0.5"></i>
                <span>短期間に複数枚申し込まない</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-red-600 mt-0.5"></i>
                <span>キャッシング枠は0円または少額に</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-red-600 mt-0.5"></i>
                <span>他社の借入がある場合は返済してから申込</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
